import React from 'react'
import { graphql, useStaticQuery } from 'gatsby'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'

const Image = props => {
  const data = useStaticQuery(graphql`
    query {
      images: allFile(filter: { extension: { in: ["png", "jpg", "jpeg", "webp"] } }) {
        edges {
          node {
            relativePath
            name
            childImageSharp {
              gatsbyImageData(placeholder: BLURRED, quality: 100)
            }
          }
        }
      }
    }
  `)

  if ((props.type && props.type === 'external') || props.filename.includes('.svg')) {
    return <img src={props.filename} alt={props.alt || props.filename} style={props.style} {...props} />
  } else {
    const image = data.images.edges.find(n => {
      const imgPathArr = n.node.relativePath.split('/')
      const imgPath = imgPathArr[imgPathArr.length - 1]

      if (props.filename.includes('testimonials/')) {
        return props.filename === n.node.relativePath
      }

      return props.filename === imgPath
    })

    const fallBack = data.images.edges.find(n => {
      return n.node.relativePath.includes(props.fallback)
    })

    if (!image) {
      const imageFallback = getImage(fallBack?.node ?? null)
      return (
        <GatsbyImage
          alt={props.alt || props.filename}
          image={imageFallback}
          imgStyle={props.style}
          className={props.className}
          quality={100}
          {...props}
        />
      )
    }

    const imageSizes = getImage(image.node)
    return (
      <GatsbyImage
        alt={props.alt || props.filename}
        image={imageSizes}
        imgStyle={props.style}
        objectFit={props.objectFit || 'contain'}
        className={props.className}
        quality={100}
        {...props}
      />
    )
  }
}

export default Image
